<template>
<div>
  <v-list-tile @click="mostrarCaixaDialogo">
    <v-list-tile-title>
      Habilitar
    </v-list-tile-title>
  </v-list-tile>

  <modal-generico :visivel.sync="visibilidadeDialogo"
                  @fechar="fecharCaixaDialogo"
                  @confirmar="habilitar">

    <template v-slot:header>
      <span><strong>{{itemOuLoteDescricao}}</strong> | Habilitar Fornecedor</span>
    </template>

    <template v-slot:primario>
      <div>
        <div class="az-text mb-3">
          <label>Fornecedor</label>
          <p>{{razaoSocial}}</p>
        </div>

        <v-textarea v-model="motivoHabilitacao"
                    :error-messages="errors.collect('Motivo da Habilitação ' + itemOuLoteDescricao)"
                    v-validate="'required'"
                    label="Motivo da Habilitação"
                    :name="'Motivo da Habilitação ' + itemOuLoteDescricao"
                    placeholder="Digite aqui seu motivo"
                    rows="3"
                    maxlength="1000"
                    :counter="1000"/>

        <v-checkbox
            v-model="habilitarTodos"
            label="Habilitar fornecedor para todos os itens ou grupos da compra"/>
      </div>
    </template>

    <template v-slot:acoes>
      <v-btn color="botao-cancelar-color" flat outline @click="fecharCaixaDialogo">
        Cancelar
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn id="botaoHabilitar" color="primary" depressed @click="habilitar">
        Confirmar
      </v-btn>
    </template>
  </modal-generico>
</div>
</template>

<script>
import ModalGenerico from '@/views/components/ModalGenerico.vue'

export default {
    name: 'AcoesHabilitar',
    $_veeValidate: {
        validator: 'new'
    },
    components: {ModalGenerico},
    props: ['itemOuLoteDescricao', 'razaoSocial'],
    data() {
        return {
            visibilidadeDialogo: false,
            motivoHabilitacao: null,
            habilitarTodos: false,
            dados: {}
        }
    },
    methods: {
        mostrarCaixaDialogo() {
            setTimeout(() => {
                this.limparCampos()
                this.visibilidadeDialogo = true
            }, 100)
        },
        fecharCaixaDialogo() {
            this.limparCampos()
            this.visibilidadeDialogo = false
        },
        async habilitar() {
            await this.validarPreenchimento()
            const dados = {
                motivo: this.motivoHabilitacao,
                habilitarTodos: this.habilitarTodos
            }
            this.$emit('habilitar', dados)
            this.fecharCaixaDialogo()
        },
        limparCampos() {
            this.habilitarTodos = false
            this.motivoHabilitacao = null
            this.$validator.reset()
        },
        async validarPreenchimento() {
            this.$nextTick(async () => {
                const estaValidado = await this.$validator.validate('Motivo da Habilitação ' + this.itemOuLoteDescricao)
                if (!estaValidado) {
                    throw new Error('Preencha todos os campos obrigatórios')
                }
            })
        }

    },
    destroyed() {
        this.fecharCaixaDialogo()
    }
}
</script>

<style scoped lang="stylus">

</style>